/**
 * @fileoverview Input Component
 *
 * Base input component using Tailwind CSS for styling.
 * Follows CLAUDE.md guidelines: Tailwind utilities, no separate CSS files.
 */

import * as React from "react";
import { cn } from "@/lib/utils";

export interface InputProps
	extends React.InputHTMLAttributes<HTMLInputElement> {
	error?: boolean;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
	({ className, type, error, ...props }, ref) => {
		return (
			<input
				type={type}
				className={cn(
					"flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm",
					"ring-offset-background",
					"file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground",
					"file:mr-4 file:py-1 file:px-3 file:rounded-md",
					"file:bg-muted file:hover:bg-muted/80 file:cursor-pointer",
					"placeholder:text-muted-foreground",
					"focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
					"disabled:cursor-not-allowed disabled:opacity-50",
					type === "file" && "cursor-pointer",
					error && "border-destructive focus-visible:ring-destructive",
					className,
				)}
				ref={ref}
				{...props}
			/>
		);
	},
);
Input.displayName = "Input";

export { Input };
